import styled from 'styled-components'
import { AutoCompleteUnstyled } from './unstyled'

export const AutoCompleteOldDesign = styled(AutoCompleteUnstyled)`
  position: relative;
  height: 56px;
  width: 100%;

  .select-field {
    background: ${props => props.theme.colors.alabaster} !important;
    border: none !important;
    border-radius: 4px !important;
    height: 50px !important;
    width: 100% !important;

    div {
      max-height: 56px !important;
    }

    hr {
      display: none !important;
    }

    button {
      height: 56px !important;
    }

    div:nth-child(2) {
      div:nth-child(2) {
        height: 56px !important;
        line-height: 56px !important;
        top: 0 !important;
        font-size: ${props =>
          props.theme.fontSizes.materialUI.selectField} !important;
        padding-left: 15px !important;
        padding-right: 35px !important;
        color: ${props => props.theme.colors.secondary} !important;
        font-weight: initial !important;
      }
    }
  }

  svg {
    position: absolute;
    width: 13px;
    height: 100%;
    right: 20px;
    z-index: ${props => props.theme.zIndexes.mainContentWrapper.first};
    transform: rotate(90deg);
    fill: ${props => props.theme.colors.secondary};
    pointer-events: none;
  }
  .label {
    display: flex;
    padding: 0;
    font-size: 16px;
    color: #546b81;
    font-family: 'Roboto Regular', Helvetica, Arial, sans-serif;
    line-height: 24px;
    margin: 0 0 10px 0;
  }
`
